(() => {
  if (customElements.get('infinite-scroll')) {
    return;
  }

  class InfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.loadingAnim = this.querySelector('.loading-anim');
      this.textLoading = this.dataset.textLoading;
      this.textEnd = this.dataset.textEnd;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        if (!this.dataset.next) {
          if (this.loadingAnim) {
            this.loadingAnim.textContent = this.textEnd;
          }
          return;
        }

        fetch(this.dataset.next)
          .then(response => response.text())
          .then(text => {
            const collection = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('[data-filter-wrapper]');

            collection
              .querySelectorAll('.product-card')
              .forEach(cardProduct => {
                document
                  .getElementById('product-grid')
                  .appendChild(cardProduct);
              });

            const infiniteScrollMarkup = collection.querySelector(
              '[data-infinite-scroll]'
            );
            document.querySelector(
              '[data-infinite-scroll]'
            ).innerHTML = infiniteScrollMarkup.innerHTML;
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px'
      }).observe(this);
    }
  }

  customElements.define('infinite-scroll', InfiniteScroll);
})();
